export function getStickyValue(FieldId) {
  return sessionStorage.getItem(`sticky_${FieldId}`) || "";
}
export function setStickyValue(FieldId, value) {
  sessionStorage.setItem(`sticky_${FieldId}`, value);
}
